import { BrandingBanner } from '../../components/BrandingBanner';
import { useOfferContext } from '../OfferContext';

export function BrandingBannerContainer() {
  const {
    author: { name, avatar, cianId, fromDeveloper },
  } = useOfferContext();

  return <BrandingBanner logoSrc={avatar} title={name || `ID: ${cianId}`} subtitle={fromDeveloper} />;
}
